/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOtherCategoryRequest
 */
export interface UpdateOtherCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOtherCategoryRequest
     */
    otherCategory: string;
}

/**
 * Check if a given object implements the UpdateOtherCategoryRequest interface.
 */
export function instanceOfUpdateOtherCategoryRequest(value: object): value is UpdateOtherCategoryRequest {
    if (!('otherCategory' in value) || value['otherCategory'] === undefined) return false;
    return true;
}

export function UpdateOtherCategoryRequestFromJSON(json: any): UpdateOtherCategoryRequest {
    return UpdateOtherCategoryRequestFromJSONTyped(json, false);
}

export function UpdateOtherCategoryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOtherCategoryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'otherCategory': json['otherCategory'],
    };
}

export function UpdateOtherCategoryRequestToJSON(value?: UpdateOtherCategoryRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'otherCategory': value['otherCategory'],
    };
}

